import React from 'react'
import {
    Box,
    Stack
} from '@mui/material'

import Header from '../../utils/header.js'
import CustomCard from '../../utils/card.js'
import * as Assets from '../../utils/assets.js'

import data from '../../data/offers.json'

const offersMedia = [
    Assets.weddings[20],
    Assets.engagements[8],
    Assets.weddings[6],
    Assets.engagements[13],
    Assets.engagements[36],
    Assets.weddings[7],
]

const Offers = () =>
    <Box
        data-aos="fade-up"
        textAlign={"center"}
        padding={{ xs: "8% 8% 0%", md: "3% 5% 0%" }}
    >
        <Header color="#000000" title="Exclusive Deals & Offers" />
        <Box
            data-aos="fade-up"
            textAlign={"center"}
        >
            <Stack
                direction={{ xs: "column", md: "row" }}
                justifyContent="space-around"
                alignItems={"flex-start"}
                flexWrap={"wrap"}
            >
                {data.data.map((item, index) => {
                    return <CustomCard
                        key={index}
                        media={offersMedia[index]}
                        title={item.title}
                        budget={item.budget}
                        description={item.description}
                    />
                })}
            </Stack>
        </Box>
    </Box>

export default Offers
